import React from "react";
import {
  Drawer,
  Button,
  Input,
  Table,
  Row,
  Col,
  Select,
  Card,
  notification,
  Popconfirm,
  Spin,
  message,
} from "antd";
import { Rose } from "@ant-design/charts";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import { contacts, designation, maintenanceTeam } from "../../../constants/url";
import { decodedToken, stateStore } from "../../../constants/constants";

class MaintenanceTeam extends React.Component {
  _isMounted = false;
  state = {
    visible: false,
    drawerInEditMode: false,
    saveIsDisabled: true,
    drawerTableData: {
      list: [],
    },
    tableData: {
      list: [],
      loading: true,
    },
    teamLeaderData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
      validateColor: "#d9d9d9",
    },
    designationData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
      validateColor: "#d9d9d9",
    },
    employeeData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
      validateColor: "#d9d9d9",
    },
    teamNameData: { selectedValue: null, validateColor: "#d9d9d9" },
  };

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 50,
    },
    {
      title: "Team Name",
      dataIndex: "TeamName",
      key: "TeamName",
      align: "center",
      fixed: "left",
      width: 100,
    },
    {
      title: "Team Leader",
      dataIndex: ["Contact", "ContactName"],
      key: "TeamLeader",
      align: "center",
      width: 100,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 80,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              style={{ color: "#1890ff" }}
              onClick={() => {
                let obj;
                let st = {
                  drawerInEditMode: item.TeamID,
                  visible: true,
                  teamNameData: { selectedValue: item.TeamName },
                  drawerTableData: { list: [] },
                };
                this.state.teamLeaderData.list.map((d, i) => {
                  if (d.ContactID === item.SupervisorID) {
                    st.teamLeaderData = {
                      list: this.state.teamLeaderData.list,
                      selectedIndex: i,
                      selectedValue: d.ContactName,
                    };
                  }
                  return d;
                });
                item.MaintenanceTeamEmployees.map((r, i) => {
                  if (!r.Contact || !r.Designation) return r;
                  obj = {};
                  obj.key = i;
                  obj.TeamID = item.TeamID;
                  obj.EmployeeID = r.ContactID;
                  obj.Employee = r.Contact.ContactName;
                  this.state.designationData.list.map((d, i) => {
                    if (d.DesignationID === r.DesignationID) {
                      obj.Designation = d.UserName;
                      obj.DesignationID = d.DesignationID;
                      obj.DesignationIndex = i;
                    }
                    return d;
                  });
                  st.drawerTableData.list.push(obj);
                  return r;
                });
                st.saveIsDisabled = st.drawerTableData.list.length === 0;
                this.setState(st);
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={() => {
                axiosInstance
                  .delete(maintenanceTeam + "/" + item.TeamID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.onReset();
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              {/* <a href="#">Delete</a> */}
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  formRef = null;

  drawerColumns = [
    {
      title: "Designation",
      dataIndex: "Designation",
      key: "Designation",
      align: "center",
      width: 110,
    },
    {
      title: "Employee",
      dataIndex: "Employee",
      key: "Employee",
      align: "center",
      width: 100,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      width: 80,
      render: (_, item) => {
        return (
          <DeleteOutlined onClick={() => this.onDeleteFromDrawerTable(item)} />
        );
      },
    },
  ];

  getInitialState = async () => {
    let state = {
      visible: false,
      drawerInEditMode: false,
      saveIsDisabled: true,
      drawerTableData: {
        list: [],
      },
      tableData: {
        list: this.state.tableData.list,
        loading: false,
      },
      teamLeaderData: {
        list: this.state.teamLeaderData.list,
        selectedIndex: null,
        selectedValue: null,
        validateColor: "#d9d9d9",
      },
      designationData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
        validateColor: "#d9d9d9",
      },
      employeeData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
        validateColor: "#d9d9d9",
      },
      teamNameData: { selectedValue: null, validateColor: "#d9d9d9" },
    };
    await axiosInstance
      .get(contacts + "?ContactCategoryID=1")
      .then((res) => {
        if (res.data.success) state.teamLeaderData.list = res.data.message.rows;
      })
      .catch(() => {});
    await axiosInstance
      .get(maintenanceTeam)
      .then((res) => {
        if (res.data.success)
          state.tableData.list = res.data.message.map((row, i) => {
            row.key = i;
            row.SN = i + 1;
            return row;
          });
      })
      .catch(() => {});
    await axiosInstance
      .get(designation)
      .then((res) => {
        if (res.data.success) state.designationData.list = res.data.message;
      })
      .catch(() => {});
    return state;
  };

  onReset = () => {
    this.getInitialState().then((st) => this.setState(st));
  };

  onCreateNew = async (drawerIsVisible = false) => {
    this.setState({
      tableData: { list: this.state.tableData.list, loading: true },
    });
    try {
      let theObj = {};
      this.state.drawerTableData.list.map((data) => {
        if (!theObj[this.state.teamNameData.selectedValue]) {
          theObj = {
            TeamID: this.state.drawerInEditMode,
            TeamName: this.state.teamNameData.selectedValue,
            SupervisorID:
              this.state.teamLeaderData.list[
                this.state.teamLeaderData.selectedIndex
              ].ContactID,
            MaintenanceTeamEmployees: [],
          };
        }
        theObj.MaintenanceTeamEmployees.push({
          ContactID: data.EmployeeID,
          DesignationID: data.DesignationID,
        });
        return data;
      });
      if (this.state.drawerInEditMode) {
        axiosInstance
          .put(maintenanceTeam, theObj)
          .then((res) => {
            if (res.data.success)
              notification.success({
                duration: 3,
                message: "Success",
                description: "Maintenance team updated!",
              });
            else
              notification.success({
                duration: 3,
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
            this.getInitialState(drawerIsVisible).then((st) => {
              this.setState(st);
            });
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      } else {
        for (let row of this.state.tableData.list)
          if (
            row.TeamName.toLowerCase() ===
            this.state.teamNameData.selectedValue.toLowerCase()
          )
            return message.error(
              "Cannot create multiple data for the same team name !"
            );
        axiosInstance
          .post(maintenanceTeam, theObj)
          .then((res) => {
            if (res.data.success)
              notification.success({
                duration: 3,
                message: "Success",
                description: "Maintenance team created!",
              });
            else
              notification.success({
                duration: 3,
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
            this.getInitialState(drawerIsVisible).then((st) => {
              this.setState(st);
            });
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      }
    } catch (err) {
      this.setState({
        tableData: { list: this.state.tableData.list, loading: false },
      });
    }
  };

  validateDrawerFields = () => {
    let error = 0,
      st = this.state;
    if (!this.state.teamNameData.selectedValue) {
      st.teamNameData.validateColor = "red";
      error += 1;
    }
    if (!this.state.teamLeaderData.selectedIndex) {
      st.teamLeaderData.validateColor = "red";
      error += 1;
    }
    if (!this.state.designationData.selectedIndex) {
      st.designationData.validateColor = "red";
      error += 1;
    }
    if (!this.state.employeeData.selectedIndex) {
      st.employeeData.validateColor = "red";
      error += 1;
    }
    this.setState(st);
    return error === 0;
  };

  onAddToTable = (value) => {
    if (this.validateDrawerFields()) {
      this.setState({
        drawerTableData: {
          list: [
            ...this.state.drawerTableData.list,
            {
              key: this.state.drawerTableData.list.length,
              Designation: this.state.designationData.selectedValue,
              DesignationIndex: this.state.designationData.selectedIndex,
              DesignationID:
                this.state.designationData.list[
                  this.state.designationData.selectedIndex
                ].DesignationID,
              Employee: this.state.employeeData.selectedValue,
              EmployeeIndex: this.state.employeeData.selectedIndex,
              EmployeeID:
                this.state.employeeData.list[
                  this.state.employeeData.selectedIndex
                ].ContactID,
            },
          ],
        },
        saveIsDisabled: false,
      });
    }
  };

  onDeleteFromDrawerTable = (value) => {
    const temp = [];
    this.state.drawerTableData.list.map((data) => {
      if (data.key !== value.key) temp.push(data);
      return data;
    });
    this.setState({
      drawerTableData: {
        list: temp,
      },
      saveIsDisabled: temp.length === 0,
    });
  };

  onChange = (value) => {
    if (value.target) {
      switch (value.target.objID) {
        case "teamName":
          this.setState({
            teamNameData: {
              selectedValue: value.target.value,
              validateColor: "#d9d9d9",
            },
          });
          break;
        default:
          break;
      }
      return;
    }
    let theIndex = value.split("-")[1];
    let theValue = value.split("-")[2];
    switch (value.split("-")[0]) {
      case "teamLeader":
        this.setState({
          teamLeaderData: {
            list: this.state.teamLeaderData.list,
            selectedIndex: theIndex,
            selectedValue: theValue,
            validateColor: "#d9d9d9",
          },
        });
        break;
      case "designation":
        this.setState(
          {
            designationData: {
              list: this.state.designationData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
              validateColor: "#d9d9d9",
            },
          },
          () =>
            axiosInstance
              .get(
                contacts +
                  "?ContactCategoryID=1&DesignationID=" +
                  this.state.designationData.list[
                    this.state.designationData.selectedIndex
                  ].DesignationID
              )
              .then((res) => {
                this.setState({
                  employeeData: {
                    list: res.data.message.rows,
                    selectedIndex: null,
                    selectedValue: null,
                    validateColor: "#d9d9d9",
                  },
                });
              })
              .catch(() => {})
        );
        break;
      case "employee":
        this.setState({
          employeeData: {
            list: this.state.employeeData.list,
            selectedIndex: theIndex,
            selectedValue: theValue,
            validateColor: "#d9d9d9",
          },
        });
        break;
      default:
        break;
    }
  };

  componentDidMount() {
    this._isMounted = true;
    if (
      decodedToken.value.User_ID !== 1 &&
      stateStore.permissions[55] &&
      stateStore.permissions[55].UView === "N"
    ) {
      message.error("You donot have permission!");
      if (stateStore.navAble)
        stateStore.navAble({
          defaultSelectedKeys: ["home"],
        });
    }
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="New Maintenance Team"
          placement="right"
          closable={false}
          onClose={this.onReset}
          visible={this.state.visible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                style={{ borderRadius: 20 }}
                type="primary"
                disabled={this.state.saveIsDisabled}
              >
                {this.state.drawerInEditMode ? "Save" : "Create"}
              </Button>
              {!this.state.drawerInEditMode ? (
                <Button
                  style={{ borderRadius: 20 }}
                  disabled={this.state.saveIsDisabled}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button onClick={this.onReset} style={{ borderRadius: 20 }}>
                Cancel
              </Button>
            </div>
          }
        >
          {/* <Form
            requiredMark
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
          > */}
          <Row>
            <Col span={6} style={{ textAlign: "left" }}>
              <label style={this.labelStyle}>Team Name</label>
            </Col>
            <Col span={1}></Col>
            <Col span={17} style={{ textAlign: "right" }}>
              <Input
                style={{
                  border: "1px solid " + this.state.teamNameData.validateColor,
                }}
                value={this.state.teamNameData.selectedValue}
                onChange={(e) => {
                  e.target.objID = "teamName";
                  this.onChange(e);
                }}
                onBlur={(e) => {
                  e.target.objID = "teamName";
                  this.onChange(e);
                }}
              ></Input>
            </Col>
          </Row>
          <Row style={{ marginTop: 10, marginBottom: 10 }}>
            <Col span={6} style={{ textAlign: "left" }}>
              <label style={this.labelStyle}>Team Leader</label>
            </Col>
            <Col span={1}></Col>
            <Col span={17}>
              <Select
                style={{
                  width: "100%",
                  border:
                    (this.state.teamLeaderData.validateColor === "red"
                      ? "1px solid "
                      : "0px solid ") + this.state.teamLeaderData.validateColor,
                }}
                showSearch
                placeholder="Select a leader"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={this.state.teamLeaderData.selectedValue}
              >
                {this.state.teamLeaderData.list.map((leader, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "teamLeader-" +
                        index +
                        "-" +
                        leader.ContactName +
                        "-" +
                        leader.ContactID
                      }
                    >
                      {leader.ContactName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          {/* <Form.Item
              key="teamName"
              name="teamName"
              label="Team Name"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: true, message: "Please enter team name" }]}
            >
              <Input
                value={this.state.teamNameData.selectedValue}
                onChange={(e) =>
                  this.setState({
                    teamNameData: { selectedValue: e.target.defaultValue },
                  })
                }
                onBlur={(e) =>
                  this.setState({
                    teamNameData: { selectedValue: e.target.defaultValue },
                  })
                }
              ></Input>
            </Form.Item>
            <Form.Item
              key="teamLeader"
              name="teamLeader"
              label="Team Leader"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: true, message: "Please select team leader" }]}
            >
              <Select
                showSearch
                placeholder="Select a leader"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={this.state.teamLeaderData.selectedValue}
              >
                {this.state.teamLeaderData.list.map((leader, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "teamLeader-" +
                        index +
                        "-" +
                        leader.ContactName +
                        "-" +
                        leader.ContactID
                      }
                    >
                      {leader.ContactName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item> */}

          <Card
            title="Employee Assignation"
            style={{ width: "100%", borderBottom: "0px" }}
            headStyle={{
              textAlign: "center",
            }}
            bodyStyle={{ padding: "10px 10px 0px 10px" }}
          >
            <Row style={{ marginTop: 10 }}>
              <Col span={7} style={{ textAlign: "left" }}>
                <label style={this.labelStyle}>Designation</label>
              </Col>
              <Col span={1}></Col>
              <Col span={16}>
                <Select
                  style={{
                    width: "100%",
                    border:
                      (this.state.designationData.validateColor === "red"
                        ? "1px solid "
                        : "0px solid ") +
                      this.state.designationData.validateColor,
                  }}
                  showSearch
                  placeholder="Select a designation"
                  optionFilterProp="children"
                  onChange={this.onChange}
                  onSearch={this.onSearch}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={this.state.designationData.selectedValue}
                >
                  {this.state.designationData.list.map((desig, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={"designation-" + index + "-" + desig.UserName}
                      >
                        {desig.UserName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={7} style={{ textAlign: "left" }}>
                <label style={this.labelStyle}>Employee</label>
              </Col>
              <Col span={1}></Col>
              <Col span={16}>
                <Select
                  style={{
                    width: "100%",
                    border:
                      (this.state.employeeData.validateColor === "red"
                        ? "1px solid "
                        : "0px solid ") + this.state.employeeData.validateColor,
                  }}
                  showSearch
                  placeholder="Select a employee"
                  optionFilterProp="children"
                  onChange={this.onChange}
                  onSearch={this.onSearch}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={this.state.employeeData.selectedValue}
                >
                  {this.state.employeeData.list.map((employee, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={"employee-" + index + "-" + employee.ContactName}
                      >
                        {employee.ContactName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Col>
            </Row>
            {/* <Form.Item
                key="designation"
                name="designation"
                label="Designation"
                labelAlign="left"
                labelCol={{ span: 7 }}
                rules={[
                  { required: true, message: "Please select designation" },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  showSearch
                  placeholder="Select a designation"
                  optionFilterProp="children"
                  onChange={this.onChange}
                  onSearch={this.onSearch}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={this.state.designationData.selectedValue}
                >
                  {this.state.designationData.list.map((desig, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={"designation-" + index + "-" + desig.UserName}
                      >
                        {desig.UserName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item
                key="employee"
                name="employee"
                label="Employee"
                labelAlign="left"
                labelCol={{ span: 7 }}
                rules={[{ required: true, message: "Please select employee" }]}
              >
                <Select
                  style={{ width: "100%" }}
                  showSearch
                  placeholder="Select a employee"
                  optionFilterProp="children"
                  onChange={this.onChange}
                  onSearch={this.onSearch}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={this.state.employeeData.selectedValue}
                >
                  {this.state.employeeData.list.map((employee, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={"employee-" + index + "-" + employee.ContactName}
                      >
                        {employee.ContactName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item> */}
            {/* <Row style={{ marginBottom: 10 }}>
                <Col span={7} style={{ textAlign: "right" }}>
                  <label>Designation</label>
                </Col>
                <Col span={1}></Col>
                <Col span={15} style={{ textAlign: "center" }}></Col>
              </Row>
              <Row style={{ marginBottom: 10 }}>
                <Col span={7} style={{ textAlign: "right" }}>
                  <label>Employee</label>
                </Col>
                <Col span={1}></Col>
                <Col span={15} style={{ textAlign: "center" }}></Col>
              </Row> */}
            <Row style={{ marginBottom: "20px", marginTop: "20px" }}>
              <Col span={24}>
                <Button
                  style={{
                    height: "100%",
                    width: "100%",
                    border: "1px solid #4CAF50",
                    borderRadius: 20,
                  }}
                  onClick={this.onAddToTable}
                >
                  Add
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <Table
                  dataSource={this.state.drawerTableData.list}
                  columns={this.drawerColumns}
                  scroll={{ y: window.innerHeight - 510 }}
                  pagination={false}
                ></Table>
              </Col>
            </Row>
          </Card>
          {/* </Form> */}
        </Drawer>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Maintenance Team</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={(e) => {
                if (
                  decodedToken.value.activeKey === "employee" &&
                  decodedToken.value.User_ID !== 1 &&
                  stateStore.permissions[55] &&
                  stateStore.permissions[55].UAdd === "N"
                )
                  return message.warning(
                    "No permission to perform this action!"
                  );
                this.setState({ visible: true });
              }}
              disabled={
                decodedToken.value.activeKey === "employee" &&
                decodedToken.value.User_ID !== 1 &&
                stateStore.permissions[55] &&
                stateStore.permissions[55].UAdd === "N"
              }
              style={{ borderRadius: 20 }}
            >
              New
            </Button>
          </Col>
        </Row>
        <Spin
          spinning={this.state.tableData.loading}
          tip="fetching and populating data..."
        >
          <Row gutter={48} style={{ paddingLeft: 10, paddingRight: 10 }}>
            {this.state.tableData.list.length ? (
              <>
                <Col span={12} xs={24} sm={24} md={8} lg={8}>
                  <Row>
                    <Col
                      span={24}
                      style={{
                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                        transition: "0.3s",
                        borderRadius: 20,
                        width: "100%",
                        padding: 10,
                      }}
                    >
                      <Rose
                        {...{
                          data: this.state.tableData.list.map((item) => {
                            item.NoOfTeamMembers =
                              (item.MaintenanceTeamEmployees || [])
                                .map((r) => {
                                  if (!r.Contact || !r.Designation)
                                    return undefined;
                                  return r;
                                })
                                .filter(Boolean).length || 5;
                            return item;
                          }),
                          xField: "TeamName",
                          yField: "NoOfTeamMembers",
                          seriesField: "TeamName",
                          label: false,
                          tooltip: {
                            formatter: (datum) => {
                              return {
                                name: "No. of members: ",
                                value: datum.NoOfTeamMembers,
                              };
                            },
                            showContent: true,
                          },
                          // (innerHeight-headerFooter-viewSearchRow)/2-marginTop-for-Column
                          height: (window.innerHeight - 98 - 50) / 2,
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={0}
                  xs={24}
                  sm={24}
                  md={0}
                  lg={0}
                  style={{ marginTop: 10 }}
                ></Col>
              </>
            ) : null}
            <Col
              {...(this.state.tableData.list.length
                ? { span: 12, xs: 24, sm: 24, md: 16, lg: 16 }
                : { span: 24 })}
            >
              <Table
                // loading={this.state.tableData.loading}
                dataSource={this.state.tableData.list}
                columns={this.columns}
                scroll={{ y: window.innerHeight - 290 }}
                pagination={{
                  size: "small",
                  disabled: false,
                  defaultPageSize: 20,
                  showQuickJumper: true,
                  showSizeChanger: true,
                  total: this.state.tableData.list.length,
                }}
                style={{
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  borderRadius: 20,
                  width: "100%",
                }}
              ></Table>
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

export default withRouter(MaintenanceTeam);
